"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSchemaProperties = exports.ZapierFormSchema = exports.FormSchema = exports.FormItemSchema = exports.AnswerSchema = exports.FormStatusEnum = void 0;
// TODO: Move all this to the shared lib whenever it's available.
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const client_schema_1 = require("./client-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.FormStatusEnum = zod_1.z.enum([
    "draft",
    "scheduled",
    "shared",
    "viewed",
    "pending",
    "submitted",
    "active",
    "deleted",
]);
/**
 * Schema for a form as it is stored in the database.
 */
const SignatureAnswerSchema = zod_1.z.object({
    signatureId: zod_1.z.string(),
    signatureRequestId: zod_1.z.string(),
});
const MultipleChoiceAnswerSchema = zod_1.z.object({
    value: zod_1.z.string(),
});
const FileSchema = zod_1.z.object({
    url: zod_1.z.string(),
    fileName: zod_1.z.string(),
    size: zod_1.z.number(),
    contentType: zod_1.z.string(),
    fullPath: zod_1.z.string().optional(),
    bucket: zod_1.z.string().optional(),
    extension: zod_1.z.string().optional(),
    itemId: zod_1.z.string().optional(),
});
exports.AnswerSchema = zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.number(),
    zod_1.z.boolean(),
    FileSchema.nullable(),
    MultipleChoiceAnswerSchema.array(),
    SignatureAnswerSchema,
]);
exports.FormItemSchema = zod_1.z.object({
    question: zod_1.z.string(),
    questionType: zod_1.z.string(),
    answer: exports.AnswerSchema.optional(),
    min: zod_1.z.number().optional(),
    max: zod_1.z.number().optional(),
});
exports.FormSchema = base_schema_1.BaseSchema.extend({
    status: exports.FormStatusEnum,
    title: zod_1.z.string().optional(),
    items: zod_1.z.array(exports.FormItemSchema),
    coachUserId: zod_1.z.string(),
    submittedAt: zod_1.z.date().optional(),
    // dynamic field filled by a document hook
    clientId: zod_1.z.string(),
    formTemplateId: zod_1.z.string().optional(),
    appointmentId: zod_1.z.string().optional(),
});
/**
 * Schema for a form as it is sent across the wire.
 */
exports.ZapierFormSchema = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string().optional(),
    client: client_schema_1.ZapierClientSchema,
    questions: zod_1.z.array(zod_1.z.object({
        question: zod_1.z.string(),
        answer: zod_1.z.string().optional(),
    })),
    hasLegalField: zod_1.z.boolean(),
    member: zod_1.z
        .object({
        id: zod_1.z.string(),
        email: zod_1.z.string().optional(),
    })
        .optional(),
});
exports.FormSchemaProperties = {
    collectionName: "forms",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
//# sourceMappingURL=form-schema.js.map